export function isElementFocused(el: HTMLElement) {
  return document.activeElement === el
}

export function isBlockFocused(id: string) {
  return document.activeElement?.getAttribute('id') === id
}
